import { useEffect, useState } from 'react';
import axios from 'axios';
import { Skeleton, Stack, Typography } from '@mui/material';

// project import
import MainCard from 'components/MainCard';
import { useGiraf } from 'giraf/index';

const BASE = process.env.REACT_APP_API_URL;

// ==============================|| DRAWER CONTENT - NAVIGATION CARD ||============================== //

const NavCard = () => {
  const { gHead } = useGiraf();
  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const token = gHead.AuthToken;
    if (!token) { setLoading(false); return; }
    axios
      .get(`${BASE}/campaign/stats`, { headers: { Authorization: token } })
      .then(({ data }) => setCampaign(data.campaign))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [gHead.AuthToken]); // eslint-disable-line

  const locationLabel = (() => {
    if (!campaign) return '';
    const { scope, ward, constituency, county } = campaign;
    if (scope === 'ward')         return `${ward || ''} Ward`;
    if (scope === 'constituency') return `${constituency || ''} Constituency`;
    if (scope === 'county')       return `${county || ''} County`;
    return 'National';
  })();

  return (
    <MainCard
      sx={{
        bgcolor: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.1)',
        m: 3,
        backdropFilter: 'blur(4px)'
      }}
    >
      <Stack spacing={1}>
        <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.45)', letterSpacing: '0.1em' }}>
          Active Campaign
        </Typography>

        {loading ? (
          <>
            <Skeleton variant="text" width="80%" sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
            <Skeleton variant="text" width="60%" sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
            <Skeleton variant="text" width="50%" sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
          </>
        ) : campaign ? (
          <>
            <Typography variant="h5" sx={{ color: '#fff' }}>
              {campaign.name}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
              {campaign.position} &mdash; {locationLabel}
            </Typography>
            <Typography variant="subtitle2" sx={{ color: '#ff9a00', fontWeight: 600 }}>
              Wallet: KES {Number(campaign.wallet_balance).toLocaleString('en-KE', { minimumFractionDigits: 2 })}
            </Typography>
          </>
        ) : (
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.4)' }}>
            No campaign found
          </Typography>
        )}
      </Stack>
    </MainCard>
  );
};

export default NavCard;
